import {getAllTeams} from '../../services/team.services';
import {getTeamBySubscriptionId} from '../../services/user.services';
export const ALL_TEAMS = 'ALL_TEAMS';
export const LOGOUT = 'LOGOUT';
export const SELECTED_TEAM = 'SELECTED_TEAM';
export const SELECTED_CLOCK = 'SELECTED_CLOCK';

export const GetAllTeamsAction = () => {
  return async (dispatch, getState) => {
    const {
      auth: {user},
    } = await getState();
    try {
      let result = await getAllTeams(user?.token);
      dispatch({
        type: ALL_TEAMS,
        payload: result.data,
      });
    } catch (e) {
      console.log(
        'error in  GetAllTeamsAction =====>>!!',
        e?.response?.data?.responseMessage,
      );
    }
  };
};

export const UpdateSelectedTeam = (selectedteamSubscriptionId = null) => {
  return async (dispatch, getState) => {
    const {
      auth: {user},
    } = await getState();
    try {
      let result = await getTeamBySubscriptionId(
        user?.token,
        selectedteamSubscriptionId,
      );
      dispatch({
        type: SELECTED_TEAM,
        payload: result.data,
      });
    } catch (e) {
      console.log('error in  UpdateSelectedTeam =====>>!!', e?.response?.data);
    }
  };
};
